import store from '@/store'
const workOrderType = store.getters.workorderDict || []
// 已失效工单子状态 1已解决 2未解决 3无需解决 4条件失效 5超时失效 6过期
const subStatusMap = ['已解决', '未解决', '无需解决', '条件失效', '超时失效', '过期']
const handleSubStatus = type => {
  if (!type) return ''
  return subStatusMap[type - 1]
}
const handleWorkOrderType = type => {
  const res = workOrderType.find(item => item.eventType == type)
  if (res) {
    return res.eventTypeContent
  } else {
    return ''
  }
}

// 获取工单类型的 eventType
const getWorkOrderEventType = eventTypeContent => {
  const res = workOrderType.find(item => item.eventTypeContent == eventTypeContent)
  if (res) {
    return res.eventType
  } else {
    return ''
  }
}
export default workOrderType
export { handleWorkOrderType, handleSubStatus, getWorkOrderEventType }
